/**
 * Background reading referenced from warnings, the generated script header and the
 * app footer. Every entry points at an article that explains the concept the tool
 * implements, so a reader who hits a warning can go and understand *why* it matters.
 */
export interface Reference {
  title: string;
  url: string;
}

export const REFERENCES = {
  robustRollups: {
    title: 'Writing robust Flux scripts for automated data rollups',
    url: 'https://taskautomation.org/automated-task-scheduling-orchestration/flux-scripting-for-task-automation/writing-robust-flux-scripts-for-automated-data-rollups/',
  },
  cascading: {
    title: 'Cascading hourly-to-daily rollups without double-counting',
    url: 'https://taskautomation.org/downsampling-aggregation-pipeline-design/multi-tier-rollup-scheduling/cascading-hourly-to-daily-rollups-without-double-counting/',
  },
  offsetTuning: {
    title: 'Per-measurement offset tuning for late IoT data',
    url: 'https://taskautomation.org/automated-task-scheduling-orchestration/cron-interval-scheduling-logic/per-measurement-offset-tuning-for-late-iot-data/',
  },
  cardinality: {
    title: 'Bounding series cardinality in Flux rollup tasks',
    url: 'https://taskautomation.org/automated-task-scheduling-orchestration/flux-scripting-for-task-automation/bounding-series-cardinality-in-flux-rollup-tasks/',
  },
  meanVsMedian: {
    title: 'Choosing mean vs median for noisy sensor rollups',
    url: 'https://taskautomation.org/downsampling-aggregation-pipeline-design/threshold-tuning-for-aggregation/choosing-mean-vs-median-for-noisy-sensor-rollups/',
  },
  windowMapping: {
    title: 'Mapping InfluxQL GROUP BY time() to Flux aggregateWindow',
    url: 'https://taskautomation.org/downsampling-aggregation-pipeline-design/continuous-query-migration-to-tasks/mapping-influxql-group-by-time-to-flux-aggregatewindow/',
  },
  retention: {
    title: 'How to configure retention policies in InfluxDB 2.x',
    url: 'https://taskautomation.org/influxdb-data-lifecycle-architecture-fundamentals/retention-policy-design/how-to-configure-retention-policies-in-influxdb-2x/',
  },
} as const satisfies Record<string, Reference>;

/** The links shown in the app footer's further-reading section. */
export const FURTHER_READING: Reference[] = [
  REFERENCES.robustRollups,
  REFERENCES.cascading,
  REFERENCES.cardinality,
  REFERENCES.windowMapping,
  REFERENCES.retention,
];
